<script>
import TgTooltip from "@/abc-dsk/components/Tooltip/TgTooltip.vue";

export default {
  name: "ActionWithTooltip",
  components: {
    TgTooltip
  },
  props: {
    showSuccess: {
      type: Boolean,
      default: false
    },
    hideOnClick: {
      type: Boolean,
      default: false
    },
    marginBottom: {
      type: Number,
      default: 8
    }
  },
  emits: ["hide", "show"]
};
</script>

<template>
  <TgTooltip
    class="action-with-tooltip"
    :hide-on-target-click="hideOnClick"
    :margin-bottom="marginBottom"
    @hide="$emit('hide')"
    @show="$emit('show')"
  >
    <slot name="element"></slot>
    <template #content>
      <slot v-if="showSuccess" name="actionSuccess">{{ text }}</slot>
      <slot v-else name="actionInitial">{{ text }}</slot>
    </template>
  </TgTooltip>
</template>
